const Menu = [

    {
        name: 'Inicio',
        path: '/inicio',
        icon : 'fas fa-home',
        translate: 'sidebar.nav.INICIO'
    },
    {
        name: 'N-035 Trabajadores',
        path: '/misresultados',
        icon : 'fas fa-book',
        translate: 'sidebar.nav.MISRESULTADOS'
    },
    {
        name: 'Mi empresa',
        path: '/miempresa',
        icon : 'fas fa-building',
        translate: 'sidebar.nav.MIEMPRESA'
    },
    {
        name: 'Mis trabajadores',
        path: '/misempleados',
        icon : 'fas fa-user-friends',
        translate: 'sidebar.nav.MISEMPLEADOS'
    },
    {
        name: 'Encuestas',
        path: '/encuestas',
        icon : 'fas fa-chalkboard-teacher',
        translate: 'sidebar.nav.ENCUESTAS'
    },
    /*{
        name: 'Configuración de encuesta',
        path: '/configuracionencuestas',
        icon : 'icon-wrench',
        translate: 'sidebar.nav.CONFIGURACIONENCUESTAS'
    },*/
    {
        name: 'Monitoreo de encuestas',
        path: '/monitoreodeencuestas',
        icon : 'fas fa-binoculars',
        translate: 'sidebar.nav.MONITOREODEENCUESTAS'
    },
    {
        name: 'Reportes de la norma',
        path: '/reportesdelanorma',
        icon : 'fas fa-chart-bar',
        translate: 'sidebar.nav.REPORTESDELANORMA'
    },
    {
        name: 'Analíticos de valor',
        path: '/reportesdevalor',
        icon : 'fas fa-chart-line',
        translate: 'sidebar.nav.REPORTESDEVALOR'
    },
    {
        name: 'Incidencias',
        path: '/incidencias',
        icon : 'fas fa-flag',
        translate: 'sidebar.nav.INCIDENCIAS'
    },
    {
        name: 'Centro de mensajes',
        path: '/centrodemensajes',
        icon : 'fas fa-envelope',
        translate: 'sidebar.nav.CENTRODEMENSAJES'
    },
    {
        name: 'Avisos',
        path: '/avisos',
        icon : 'fas fa-newspaper',
        translate: 'sidebar.nav.AVISOS'
    },
    {
        name: 'Soporte y servicios',
        path: '/ayuda',
        icon : 'fab fa-whmcs',
        translate: 'sidebar.nav.AYUDA'
    },
    {
        name: 'Cambiar contraseña',
        path: '/cambiarcontrasena',
        icon : 'fab fa-whmcs',
        translate: 'sidebar.nav.CAMBIARCONTRASENA'
    },
    {
        name: 'Cerrar sesión',
        path: '/cerrarsesion',
        icon : 'fas fa-sign-out-alt',
        translate: 'sidebar.nav.CERRARSESION'
    }
];


export default Menu;
